import Head from "next/head";
import styles from "./404.module.scss";
import Link from "next/link";
import { svgImages } from "@/lib/svgImages";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import { GetStaticProps, GetStaticPaths } from "next";

import { useEffect, useRef } from "react";
import { gsap } from "gsap";

export default function Custom404() {
  const { t } = useTranslation();
  const router = useRouter();
  const { lang } = router.query;

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Main container animation
    gsap.to(container, {
      y: "+=20",
      duration: 2,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut",
    });

    const qrSize = 150;

    processQRCanvas(container, qrSize);

    function processQRCanvas(container: HTMLElement, qrSize: number) {
      const gridSize = 25;
      const blockSize = qrSize / gridSize;

      for (let row = 0; row < gridSize; row++) {
        for (let col = 0; col < gridSize; col++) {
          const isInTopRight =
            row < gridSize * (Math.random() * 0.2 + 0.4) &&
            col > gridSize * (Math.random() * 0.3 + 0.4);
          if (isInTopRight) {
            createFlyingPiece(col * blockSize, row * blockSize, blockSize);
          }
        }
      }
    }

    function createFlyingPiece(x: number, y: number, size: number) {
      const piece = document.createElement("div");
      piece.classList.add("flying-piece");
      piece.style.left = `${x}px`;
      piece.style.top = `${y}px`;
      piece.style.width = `${size}px`;
      piece.style.height = `${size}px`;
      piece.style.backgroundColor = "black";
      piece.style.position = "absolute";
      piece.style.zIndex = "10";
      piece.style.opacity = "1";
      container.appendChild(piece);

      const angle = Math.random() * Math.PI * 0.15 - Math.PI * 0.075;
      const speed = Math.random() * 100 + 50;
      const velocityX = Math.cos(angle) * (speed * 0.2);
      const velocityY = Math.sin(angle) * (speed * 0.4);
      const velocityZ = Math.random() * 250 + 150;

      gsap.to(piece, {
        x: velocityX,
        y: velocityY,
        scale: 0.2,
        opacity: 0,
        duration: Math.random() * 1.8 + 1.2,
        ease: "power3.out",
        onComplete: () => {
          piece.remove();
          setTimeout(() => createFlyingPiece(x, y, size), Math.random() * 2000);
        },
      });
    }

    // Cleanup function
    return () => {
      if (container) {
        gsap.killTweensOf(container);
        const flyingPieces = container.querySelectorAll(".flying-piece");
        flyingPieces.forEach((piece) => piece.remove());
      }
    };
  }, []);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Main container animation
    gsap.to(container, {
      y: "+=20",
      duration: 2,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut",
    });

    const qrSize = 150;

    processQRCanvas(container, qrSize);

    function processQRCanvas(container: HTMLElement, qrSize: number) {
      const gridSize = 25;
      const blockSize = qrSize / gridSize;

      for (let row = 0; row < gridSize; row++) {
        for (let col = 0; col < gridSize; col++) {
          const isInTopRight =
            row < gridSize * (Math.random() * 0.2 + 0.4) &&
            col > gridSize * (Math.random() * 0.3 + 0.4);
          if (isInTopRight) {
            createFlyingPiece(col * blockSize, row * blockSize, blockSize);
          }
        }
      }
    }

    function createFlyingPiece(x: number, y: number, size: number) {
      const piece = document.createElement("div");
      piece.classList.add("flying-piece");
      piece.style.left = `${x}px`;
      piece.style.top = `${y}px`;
      piece.style.width = `${size}px`;
      piece.style.height = `${size}px`;
      piece.style.backgroundColor = "black";
      piece.style.position = "absolute";
      piece.style.zIndex = "10";
      piece.style.opacity = "1";
      container.appendChild(piece);

      const angle = Math.random() * Math.PI * 0.15 - Math.PI * 0.075;
      const speed = Math.random() * 100 + 50;
      const velocityX = Math.cos(angle) * (speed * 0.2);
      const velocityY = Math.sin(angle) * (speed * 0.4);
      const velocityZ = Math.random() * 250 + 150;

      gsap.to(piece, {
        x: velocityX,
        y: velocityY,
        scale: 0.2,
        opacity: 0,
        duration: Math.random() * 1.8 + 1.2,
        ease: "power3.out",
        onComplete: () => {
          piece.remove();
          setTimeout(() => createFlyingPiece(x, y, size), Math.random() * 2000);
        },
      });
    }

    // Cleanup function
    return () => {
      if (container) {
        gsap.killTweensOf(container);
        const flyingPieces = container.querySelectorAll(".flying-piece");
        flyingPieces.forEach((piece) => piece.remove());
      }
    };
  }, []);

  return (
    <>
      <Head>
        <title>{t("error404.title")}</title>
        <meta name="description" content={t("error404.description")} />
        <meta name="robots" content="noindex, nofollow" />
      </Head>

      <div className={styles.container}>
        <div className={styles.layout}>
          <div>
            <h1 className={styles.errorNumber}>{t("error404.errorNumber")}</h1>
            <h2 className={styles.errorTitle}>{t("error404.errorTitle")}</h2>
            <p className={styles.errorDescription}>
              {t("error404.errorDescription")}
            </p>
            <div className={styles.buttonContainer}>
              <Link
                href={`/${lang}/`}
                className={`${styles.btn} ${styles["btn-primary"]}`}
              >
                {t("error404.goBackHome")}
              </Link>
            </div>
          </div>
          <div className={styles.content} ref={containerRef}>
            <span
              dangerouslySetInnerHTML={{ __html: svgImages.broken_qrcode }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

// Hide layout for 404 page
(Custom404 as any).hideLayout = true;

// Generate static paths for both languages
export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [{ params: { lang: "en" } }, { params: { lang: "ar" } }],
    fallback: false,
  };
};

// Generate static props for 404 page
// Note: HTTP status code 404 is automatically set by Next.js for pages in the 404.tsx file
export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};
